export enum RugbyUnionKickAttribute {
  KickForTouch = 1066,
  Pass = 2960,
  TapKick = 2988,
  Clearance = 2961,
  RestartKick = 2962,
  UpAndUnder = 2963,
  CollectedByOffense = 2964,
  FiftyTwentyTwoKick = 2965,
}
